/* eslint-disable */
import * as Types from '../../graphql/types.generated';

import * as Operations from './ViewerContext.graphql';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ViewerContextQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ViewerContextQuery = {
    __typename: 'Query';
    viewer: Types.Maybe<{ __typename: 'User' } & ViewerContext_UserFragment>;
};

export type ViewerContext_UserFragment = {
    __typename: 'User';
    id: string;
    displayName: string;
    isAdmin: boolean;
    isDesigner: boolean;
    designerLevel: Types.DesignerLevel;
    isCertifiedDesigner: boolean;
    isPartnershipDesigner: boolean;
    certifications: Array<string>;
};

export type ViewerContextComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<ViewerContextQuery, ViewerContextQueryVariables>,
    'query'
>;

export const ViewerContextComponent = (props: ViewerContextComponentProps) => (
    <ApolloReactComponents.Query<ViewerContextQuery, ViewerContextQueryVariables>
        query={Operations.ViewerContext}
        {...props}
    />
);

/**
 * __useViewerContextQuery__
 *
 * To run a query within a React component, call `useViewerContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerContextQuery(
    baseOptions?: Apollo.QueryHookOptions<ViewerContextQuery, ViewerContextQueryVariables>
) {
    return Apollo.useQuery<ViewerContextQuery, ViewerContextQueryVariables>(
        Operations.ViewerContext,
        baseOptions
    );
}
export function useViewerContextLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ViewerContextQuery, ViewerContextQueryVariables>
) {
    return Apollo.useLazyQuery<ViewerContextQuery, ViewerContextQueryVariables>(
        Operations.ViewerContext,
        baseOptions
    );
}
export type ViewerContextQueryHookResult = ReturnType<typeof useViewerContextQuery>;
export type ViewerContextLazyQueryHookResult = ReturnType<typeof useViewerContextLazyQuery>;
export type ViewerContextQueryResult = Apollo.QueryResult<
    ViewerContextQuery,
    ViewerContextQueryVariables
>;
